<template>
  <div :class="[
    { 'as-statistic-home': isHomePage },
    `as-parent-statics as-parent-statics-${siteName}`,
  ]">
    <div class="as-nav-tabs-btn as-nav-tabs-btn__border">
      <div v-for="index in 3" :key="index">
        <SkeletonLoader width="65px" height="30px" :line="1" />
      </div>
    </div>

    <div class="as-tab-content">
      <div class="as-statistics" :class="{
        'as-scrolling as-scrolling__have-tab as-scrolling__result-popup': !isHomePage,
        'as-home-scrollable-content': isHomePage,
      }">
        <div class="as-statistics__content">
          <div class="as-statistics__line" v-for="index in 10" :key="index">
            <div class="as-statistics__value as-statistics__value--home">
              <SkeletonLoader width="30px" height="10px" :line="1" />
            </div>
            <div class="as-statistics__bar-wrapper as-statistics__bar-wrapper--home">
              <div class="as-statistics__bar as-statistics__bar--home">
                <SkeletonLoader width="100px" height="10px" :line="1" />
              </div>
            </div>
            <span class="as-statistics__title"><SkeletonLoader width="80px" height="10px" :line="1" /></span>
            <span class="as-statistics__bar-wrapper as-statistics__bar-wrapper--away">
              <span class="as-statistics__bar as-statistics__bar--away">
                <SkeletonLoader width="100px" height="10px" :line="1" />
              </span>
            </span>
            <span class="as-statistics__value as-statistics__value--away">
              <SkeletonLoader width="30px" height="10px" :line="1" />
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, computed } from "vue";
import { usecommonStore } from "~src/stores/CommonStore";
import SkeletonLoader from "~src/components/SkeletonLoader.vue";

const commonStore = usecommonStore();

interface IProps {
  isHomePage?: boolean;
}

const props = withDefaults(defineProps<IProps>(), {
  isHomePage: false,
});

const siteName = computed(() => commonStore.getSiteName);
</script>

<script lang="ts">
export default {};
</script>
